import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ChatMessages = ({ messages, isLoading, messagesEndRef, setMessages }) => {
  return (
    <div className="messages-container">
      {messages.length === 0 ? (
        <div className="welcome-message">
          <h1>Hello! How can I help you today?</h1>
        </div>
      ) : (
        <>
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.role}`}>
              <div className="message-content">
                {message.role === 'user' ? (
                  <div className="user-bubble">{message.content}</div>
                ) : (
                  <>
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>

                    {/* Agent Decision Display */}
                    {message.agentDecision && (
                      <div style={{
                        marginTop: '6px',
                        fontSize: '11px',
                        color: 'var(--text-secondary)',
                        backgroundColor: 'rgba(74, 222, 128, 0.1)',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        display: 'inline-block'
                      }}>
                        🤖 Agent used: {message.agentDecision.decision.replace('_', ' ').toLowerCase()}
                      </div>
                    )}

                    {/* Document Rewriter Agent Interactive Elements */}
                    {message.documentRewriterData && message.documentRewriterData.selectedDocument && (
                      <div style={{
                        marginTop: '12px',
                        padding: '12px',
                        backgroundColor: 'var(--bg-secondary)',
                        borderRadius: '8px',
                        border: '1px solid var(--border-color)'
                      }}>
                        <h4 style={{ margin: '0 0 8px 0', color: 'var(--text-primary)' }}>📄 Selected Document</h4>
                        <div style={{
                          marginBottom: '8px',
                          padding: '8px',
                          backgroundColor: 'rgba(74, 222, 128, 0.1)',
                          borderRadius: '4px'
                        }}>
                          <strong>📄 Document:</strong> {message.documentRewriterData.selectedDocument}
                        </div>
                      </div>
                    )}

                    {message.documentRewriterData && message.documentRewriterData.entityMapping && Object.keys(message.documentRewriterData.entityMapping).length > 0 && (
                      <div style={{
                        marginTop: '12px',
                        padding: '12px',
                        backgroundColor: 'var(--bg-secondary)',
                        borderRadius: '8px',
                        border: '1px solid var(--border-color)'
                      }}>
                        <h4 style={{ margin: '0 0 8px 0', color: 'var(--text-primary)' }}>🔄 Entity Mapping</h4>
                        <div style={{ fontSize: '13px' }}>
                          {Object.entries(message.documentRewriterData.entityMapping).map(([original, replacement], idx) => (
                            <div key={idx} style={{
                              marginBottom: '4px',
                              padding: '4px 8px',
                              backgroundColor: 'var(--hover-color)',
                              borderRadius: '4px'
                            }}>
                              <span style={{ color: 'var(--error-color)' }}>"{original}"</span>
                              {' → '}
                              <span style={{ color: 'var(--success-color)' }}>"{replacement}"</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {message.documentRewriterData && message.documentRewriterData.downloadUrl && (
                      <div style={{
                        marginTop: '12px',
                        padding: '12px',
                        backgroundColor: 'var(--bg-secondary)',
                        borderRadius: '8px',
                        border: '1px solid var(--border-color)'
                      }}>
                        <h4 style={{ margin: '0 0 8px 0', color: 'var(--text-primary)' }}>✅ Document Ready</h4>
                        <button
                          onClick={() => {
                            // Create a proper download by fetching the file and creating a blob
                            fetch(message.documentRewriterData.downloadUrl)
                              .then(response => {
                                if (!response.ok) {
                                  throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return response.blob();
                              })
                              .then(blob => {
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.style.display = 'none';
                                a.href = url;
                                a.download = message.documentRewriterData.filename || message.documentRewriterData.downloadUrl.split('/').pop().replace(/%20/g, ' ');
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(url);
                                document.body.removeChild(a);
                              })
                              .catch(error => {
                                console.error('Download failed:', error);
                                alert('Download failed. Please try again.');
                              });
                          }}
                          style={{
                            display: 'inline-block',
                            padding: '8px 16px',
                            backgroundColor: 'var(--primary-color)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                          }}
                        >
                          📥 Download Rewritten Document
                        </button>
                      </div>
                    )}
                    {(message.webCitations?.length || message.ragCitations?.length) ? (
                      <div style={{ marginTop: '8px' }}>
                        <button
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            backgroundColor: 'var(--accent-color)',
                            border: 'none',
                            borderRadius: '6px',
                            color: 'white',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => { e.target.style.backgroundColor = 'var(--accent-hover)'; }}
                          onMouseOut={(e) => { e.target.style.backgroundColor = 'var(--accent-color)'; }}
                          onClick={() => {
                            setMessages(prev => {
                              const upd = [...prev];
                              upd[index] = { ...upd[index], showSources: !upd[index].showSources };
                              return upd;
                            });
                          }}
                        >
                          {message.showSources ? '▾ Hide sources' : '▸ Show sources'}
                        </button>
                        {message.showSources && (
                          <div style={{ marginTop: '6px', fontSize: '14px' }}>
                            {message.webCitations?.length > 0 && (
                              <div>
                                <strong>🌐 Web sources:</strong>
                                <ul>
                                  {message.webCitations.map((c, i) => (
                                    <li key={i}><a href={c.url} target="_blank" rel="noreferrer">{c.title || c.url}</a></li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {message.ragCitations?.length > 0 && (
                              <div>
                                <strong>📚 Knowledge-base sources:</strong>
                                <ul>
                                  {message.ragCitations.map((c, i) => (
                                    <li key={i}>
                                      <strong>
                                        {c.authority_emoji} [{c.authority_name}] {c.source || c.filename || 'Document'}
                                      </strong> (sim {c.similarity ? c.similarity.toFixed(2) : ''})
                                      <br />
                                      <em>{c.content ? (c.content.length > 150 ? c.content.substring(0, 150) + '...' : c.content) : 'No content'}</em>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          ))}

          {isLoading && (
            <div className="message assistant">
              <div className="message-content">
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessages;
